import React from "react";
import "./TrustBar.css";

const TRUST_ITEMS = [
  { label: "Family-owned", detail: "Bardstown, Kentucky" },
  { label: "Ages 18 months – 18 years", detail: "All skill levels" },
  { label: "Recreational & competitive", detail: "From preschool to team" },
  { label: "ACE", detail: "Active · Confident · Empowered" },
];

const TrustBar = () => (
  <section className="home-trust" aria-label="Quick facts">
    <div className="home-trust__inner">
      {TRUST_ITEMS.map((item) => (
        <div key={item.label} className="home-trust__item">
          <span className="home-trust__label">{item.label}</span>
          <span className="home-trust__detail">{item.detail}</span>
        </div>
      ))}
    </div>
  </section>
);

export default TrustBar;
